var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0262 13.8473L18.5951 17.4163L17.4166 18.5948L13.8477 15.0258C12.5644 16.0525 10.937 16.6667 9.16699 16.6667C5.02699 16.6667 1.66699 13.3067 1.66699 9.16667C1.66699 5.02667 5.02699 1.66667 9.16699 1.66667C13.307 1.66667 16.667 5.02667 16.667 9.16667C16.667 10.9367 16.0528 12.5641 15.0262 13.8473ZM13.3542 13.229C14.3732 12.1788 15.0003 10.7463 15.0003 9.16667C15.0003 5.94376 12.3899 3.33334 9.16699 3.33334C5.94408 3.33334 3.33366 5.94376 3.33366 9.16667C3.33366 12.3896 5.94408 15 9.16699 15C10.7467 15 12.1792 14.3729 13.2293 13.3539L13.3542 13.229Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSmall);
export default __webpack_public_path__ + "static/media/search_small.2a5d9d19180cd6b2d799d7ec1b9a87fb.svg";
export { ForwardRef as ReactComponent };